'use strict';

var getThemeByProps = require('@userzoomlibraries/toolkit-theme-manager/get-theme-by-props');
var styled = require('styled-components');
var React = require('react');
var PropTypes = require('@userzoomlibraries/toolkit-js-utils/prop-types');
var noop = require('@userzoomlibraries/toolkit-js-utils/noop');
var isFunction = require('@userzoomlibraries/toolkit-js-utils/is-function');
var isString = require('@userzoomlibraries/toolkit-js-utils/is-string');
var useAsyncHandlers = require('@userzoomlibraries/toolkit-react-utils/use-async-handlers');
var useAriaAttributes = require('@userzoomlibraries/toolkit-react-utils/use-aria-attributes');
var useDataAttributes = require('@userzoomlibraries/toolkit-react-utils/use-data-attributes');
var useTabIndexAttribute = require('@userzoomlibraries/toolkit-react-utils/use-tab-index-attribute');
var Icon = require('@userzoomlibraries/toolkit-icon');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var getThemeByProps__default = /*#__PURE__*/_interopDefaultCompat(getThemeByProps);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultCompat(PropTypes);
var noop__default = /*#__PURE__*/_interopDefaultCompat(noop);
var isFunction__default = /*#__PURE__*/_interopDefaultCompat(isFunction);
var isString__default = /*#__PURE__*/_interopDefaultCompat(isString);
var useAsyncHandlers__default = /*#__PURE__*/_interopDefaultCompat(useAsyncHandlers);
var useAriaAttributes__default = /*#__PURE__*/_interopDefaultCompat(useAriaAttributes);
var useDataAttributes__default = /*#__PURE__*/_interopDefaultCompat(useDataAttributes);
var useTabIndexAttribute__default = /*#__PURE__*/_interopDefaultCompat(useTabIndexAttribute);
var Icon__default = /*#__PURE__*/_interopDefaultCompat(Icon);

var _excluded = ["id", "className", "async", "type", "disabled", "form", "children", "leftIcon", "rightIcon", "onClick", "onFocus", "onBlur", "onTouchStart", "onTouchEnd", "onMouseDown", "onMouseUp", "onKeyUp", "onKeyDown", "onMouseOver", "onMouseOut", "onMouseEnter", "onMouseLeave"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Button$1 = /*#__PURE__*/React__default["default"].forwardRef(function (_ref, ref) {
  var id = _ref.id,
      className = _ref.className,
      async = _ref.async,
      type = _ref.type,
      disabled = _ref.disabled,
      form = _ref.form,
      children = _ref.children,
      leftIcon = _ref.leftIcon,
      rightIcon = _ref.rightIcon,
      onClick = _ref.onClick,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onTouchStart = _ref.onTouchStart,
      onTouchEnd = _ref.onTouchEnd,
      onMouseDown = _ref.onMouseDown,
      onMouseUp = _ref.onMouseUp,
      onKeyUp = _ref.onKeyUp,
      onKeyDown = _ref.onKeyDown,
      onMouseOver = _ref.onMouseOver,
      onMouseOut = _ref.onMouseOut,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      rest = _objectWithoutProperties(_ref, _excluded);

  var ariaAttributes = useAriaAttributes__default["default"](rest, {
    excludedAttributes: ['aria-disabled', 'aria-busy']
  });
  var dataAttributes = useDataAttributes__default["default"](rest);
  var tabIndexattribute = useTabIndexAttribute__default["default"](rest);

  var _useAsyncHandlers = useAsyncHandlers__default["default"]({
    async: async,
    onClick: onClick
  }),
      _useAsyncHandlers$onC = _useAsyncHandlers.onClick,
      isLoading = _useAsyncHandlers$onC.isLoading,
      asyncOnClick = _useAsyncHandlers$onC.onClick;

  var finalChildren = isFunction__default["default"](children) ? children : function () {
    return /*#__PURE__*/jsxRuntime.jsxs(React.Fragment, {
      children: [isString__default["default"](leftIcon) && /*#__PURE__*/jsxRuntime.jsx(Icon__default["default"], {
        className: "gz-button__left-icon",
        name: leftIcon
      }), children, isString__default["default"](rightIcon) && /*#__PURE__*/jsxRuntime.jsx(Icon__default["default"], {
        className: "gz-button__right-icon",
        name: rightIcon
      })]
    });
  };
  return /*#__PURE__*/jsxRuntime.jsx("button", _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    // eslint-disable-line jsx-a11y/role-supports-aria-props
    id: id,
    className: "gz-button ".concat(className),
    ref: ref,
    type: type,
    disabled: disabled || isLoading,
    form: form,
    onClick: asyncOnClick,
    onFocus: onFocus,
    onBlur: onBlur,
    onTouchStart: onTouchStart,
    onTouchEnd: onTouchEnd,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    onKeyUp: onKeyUp,
    onKeyDown: onKeyDown,
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    "aria-disabled": disabled || isLoading,
    "aria-busy": isLoading // eslint-disable-next-line react/jsx-props-no-spreading

  }, ariaAttributes), dataAttributes), tabIndexattribute), {}, {
    children: finalChildren({
      isLoading: isLoading
    })
  }));
});
Button$1.COMPONENT_ID = 'Gearz.Button';
Button$1.displayName = Button$1.COMPONENT_ID;
Button$1.propTypes = {
  id: PropTypes__default["default"].stringWithDescription('Id of the button.'),
  className: PropTypes__default["default"].stringWithDescription('Custom class to be applied.'),
  type: PropTypes__default["default"].oneOfWithDescription(['button', 'reset', 'submit'], 'Type of the button.'),
  async: PropTypes__default["default"].boolWithDescription('Flag to make the button async.'),
  disabled: PropTypes__default["default"].boolWithDescription('Flag to make the button disable.'),
  children: PropTypes__default["default"].oneOfTypeWithDescription([PropTypes__default["default"].node, PropTypes__default["default"].func], 'Content of the button. `({ isLoading }) => {}`'),
  form: PropTypes__default["default"].stringWithDescription('Name of the form to submit or reset it.'),
  leftIcon: PropTypes__default["default"].stringWithDescription('Name of the icon to show at the beginning of the text.'),
  rightIcon: PropTypes__default["default"].stringWithDescription('Name of the icon to show at the end of the text.'),
  onClick: PropTypes__default["default"].funcWithDescription('Callback called when click event is triggered. When `async` is true, this callback receive an extra parameter called `callback`. `(event, callback?) => {}`'),
  onFocus: PropTypes__default["default"].funcWithDescription('Callback called when focus event is triggered.'),
  onBlur: PropTypes__default["default"].funcWithDescription('Callback called when blur event is triggered.'),
  onTouchStart: PropTypes__default["default"].funcWithDescription('Callback called when touchstart event is triggered.'),
  onTouchEnd: PropTypes__default["default"].funcWithDescription('Callback called when touchend event is triggered.'),
  onMouseDown: PropTypes__default["default"].funcWithDescription('Callback called when mousedown event is triggered.'),
  onMouseUp: PropTypes__default["default"].funcWithDescription('Callback called when mouseup event is triggered.'),
  onKeyUp: PropTypes__default["default"].funcWithDescription('Callback called when keyup event is triggered.'),
  onKeyDown: PropTypes__default["default"].funcWithDescription('Callback called when keydown event is triggered.'),
  onMouseOver: PropTypes__default["default"].funcWithDescription('Callback called when mouseover event is triggered.'),
  onMouseOut: PropTypes__default["default"].funcWithDescription('Callback called when mouseout event is triggered.'),
  onMouseEnter: PropTypes__default["default"].funcWithDescription('Callback called when mouseenter event is triggered.'),
  onMouseLeave: PropTypes__default["default"].funcWithDescription('Callback called when mouseleave event is triggered.')
};
Button$1.defaultProps = {
  id: null,
  className: '',
  type: 'button',
  async: false,
  disabled: false,
  children: null,
  form: null,
  leftIcon: null,
  rightIcon: null,
  onClick: noop__default["default"],
  onFocus: noop__default["default"],
  onBlur: noop__default["default"],
  onTouchStart: noop__default["default"],
  onTouchEnd: noop__default["default"],
  onMouseDown: noop__default["default"],
  onMouseUp: noop__default["default"],
  onKeyUp: noop__default["default"],
  onKeyDown: noop__default["default"],
  onMouseOver: noop__default["default"],
  onMouseOut: noop__default["default"],
  onMouseEnter: noop__default["default"],
  onMouseLeave: noop__default["default"]
};

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var Button = styled__default["default"](Button$1).withConfig({
  componentId: "gz-button-1679041998923__sc-hhnj9n-0"
})(["align-items:center;display:inline-flex;flex:0 0 auto;justify-content:center;overflow:hidden;position:relative;text-align:center;user-select:none;vertical-align:middle;white-space:nowrap;&:disabled{cursor:not-allowed;}&:not(:disabled){cursor:pointer;&:hover{text-decoration:none;}&:focus{outline:0;}}.gz-button__left-icon{margin-right:4px;}.gz-button__right-icon{margin-left:4px;}", ""], function (props) {
  return getThemeByProps__default["default"]({
    componentId: Button$1.COMPONENT_ID,
    props: props
  });
});
Button.displayName = Button$1.displayName;
Button.propTypes = Button$1.propTypes;
Button.defaultProps = Button$1.defaultProps;

exports.Button = Button;
